require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2005-03-06-eat-your-own-dog-food.json") })
        }
      }, "path---articles-2005-03-06-eat-your-own-dog-food");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2005-03-06-eat-your-own-dog-food!./.cache/json/articles-2005-03-06-eat-your-own-dog-food.json
// module id = 383
// module chunks = 231608221292675